<template>
  <div class="exp-run-page">
    <loading v-if="isLoading"></loading>
    <div class="soft-list" v-show="!isRemote && softwares.length > 0">
      <div class="soft-title">仿真软件</div>
      <div class="soft-item" v-for="soft in softwares" :key="soft.id" @click="clickSoftLocal(soft)">
        <img :src="soft.icon | filterUrl" alt=""/>
        {{ soft.name }}
      </div>
    </div>
    <div :class="{
      'exp-run-main': true,
      'is-full': isFull
    }" ref="main">
      <div class="main-left" :class="{'left-full': !isRemote }" @click="mouseLeftClick">
        <div class="left-tabs">
          <span
              :class="{active: type === 'doc'}"
              @click="type = 'doc'"
          >实验文档</span>
          <span
              :class="{active: type === 'report'}"
              @click="type = 'report'"
          >实验报告</span>
          <span class="left-tabs-close" @click="closeSoftWare(true)" v-if="!isRemote">退出实验</span>
          <img class="full-img" src="~@/assets/imgs/ic_full_screen_document.png" alt="" @click="isFull = !isFull"/>
        </div>
        <keep-alive>
          <component
              :is="typeComp[type]" :expContentType="expContentType" :baseUrl="baseUrl" :uid="uid"
              :isSave="isSave" :showDoc="showDoc" :newReport="newReport" :isStatus="isStatus"
              :expRecordInfo="expData" @exit="closeSoftWare(true)"
              :style="{
                display: showDoc ? 'block' : 'none'
              }"
          />
        </keep-alive>
      </div>
      <div :class="{
        'main-right': true,
        'full': !showDoc
      }" v-show="isRemote">
        <div class="vm-area">
          <template v-if="!isFull">
            <span
                class="action-btn" ref="showDoc" :class="showDoc ? 'hide': 'show'" @click="handShowDoc"
                @mousedown="mouseDownHandDoc($event)" @mouseup="mouseUpHandDoc($event)"
            >
              {{ showDoc ? '隐藏' : '显示' }}文档
            </span>
            <span
                class="action-btn" ref="showTools" :class="showLabTools?'tools-hide': 'tools-show'"
                @click="handShowTools" @mousedown="mouseDownHandTools($event)"
                @mouseup="mouseUpHandTools($event)"
            >{{ showLabTools ? '隐藏' : '显示' }}工具栏</span>
          </template>
          <div :class="{'tools-bar': true, 'tb-show': showLabTools }" v-show="showLabTools">
            <div class="btn-list">
              <template v-if="!laya3D">
                <div class="title-time">
                  <span>剩余时长</span>
                  <time v-text="time"></time>
                </div>
                <el-input
                    size="small" type="number" :min="clientProperties.minScale" :max="clientProperties.maxScale"
                    :step="0.01" v-model="clientProperties.scale"
                >
                  <template slot="prepend">缩放</template>
                </el-input>
                <el-button type="warning" round :disabled="delayedCount <= 0 || leftTime > 600" @click="addTimeToSoft">
                  延时
                </el-button>
              </template>
              <el-button type="danger" round @click="handleConfirmClose">停止实验</el-button>
            </div>
            <div class="tool-list">
              <div class="tool">
                <img src="~@/assets/imgs/ic_shear.png" alt=""/>
                <span class="tool-title" @click="handTestSpeed">网络检测</span>
              </div>
              <div class="tool" @click="fullScreen">
                <img src="~@/assets/imgs/ic_desktop_full_screen.png" alt=""/>
                <span class="tool-title" v-text="`${deskFull ? '退出' : '桌面'}全屏`"></span>
              </div>
            </div>
          </div>
          <div class="desktop-content" @click="mouseRightClick">
            <div class="display">
              <div id="display" ref="display"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="剪切板" :visible.sync="clipBoardDialog">
      <div class="clipboard-body">
        <div class="text">
          <p>
            <strong>复制外部内容到仿真软件内：</strong>
            <span>粘贴内容到下方输入框—点击保存—在仿真软件中粘贴</span>
          </p>
          <p>
            <span>注：1. 粘贴前请不要选中任何内容，否则会出现粘贴错误。</span>
          </p>
          <p style="text-indent: 2em">
            <span>2. 实验文档不支持Ctrl+C复制，请选中内容—右键—复制。</span>
          </p>
          <p>
            <strong>获取仿真软件中的内容：</strong>
            <span>复制环境中的内容—在下方输入框中复制内容</span>
          </p>
        </div>
        <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="clipBoardText"></el-input>
        <el-row>
          <el-button type="success" size="small">保 存</el-button>
        </el-row>
      </div>
      <span slot="footer">
        <el-button type="info" size="small" @click="handleClipBoard">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="使用说明" :visible.sync="directionsDialog">
      <div style="width:100%">
        <img src="../../../assets/imgs/directions.png" alt style="width:100%"/>
      </div>
      <span slot="footer">
        <el-button type="info" size="small" @click="directionsDialog = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="open5G" :fullscreen="true" class="dialog5G">
      <iframe :src="url5g" width="100%" height="100%" id="iframeId"></iframe>
    </el-dialog>

    <el-dialog :visible.sync="openScore" title="查看成绩" width="1124px" class="score-see">
      <shenbao-report :expRecordUid="$route.params.uid" :isCreated="false"/>
    </el-dialog>

    <speedTest ref="speedTest"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Guacamole from '@/components/guacamole';
import {baseUrl, intranetIp, path, softPort} from '@/config/env'
import {exitFullScreen, jumpToSearchUrl, reqFullScreen} from '@/utils/util'
import {filterMarkdownHtml} from '@/utils/doc'
import Loading from '@/components/common/loading'
import speedTest from "@/components/common/speed-test" //测试网络状态弹窗
import expRunDoc from './components/exp-run-doc'
import expRunReport from './components/exp-run-report'
import shenbaoReport from '@/views/declare/components/shenbao-report'
import {getExpRuningUrl} from '@/api/websocket'
import {getDetail} from "@/api/lab/lesson"
import {getMyExpDetail} from '@/api/lab/experiment'
import {add} from "@/api/lab/lab-exp-log"
import {getLocalLink} from '@/api/exp/expsoftware'

export default {
  components: {
    expRunDoc,
    expRunReport,
    Loading,
    speedTest,
    shenbaoReport,
  },
  data () {
    return {
      openScore: false,
      open5G: false,
      url5g: '',
      mouseFlag: false,
      baseUrl: '',
      uid: '', // 学生实验记录UID
      ticket: "", // 排队sid
      labExpUid: "",
      shenbaoKey: "",
      path: '',
      startExpTime: null,
      expContentType: null,
      // 是否为3D仿真项目
      laya3D: false,
      isLoading: true,
      newReport: '',
      delayedCount: 3, // 可延时的次数
      startType: '', // 开始实验类型   local 本地实验  remote 远程实验
      isFull: false,
      deskFull: false, // 是否桌面全屏
      expData: {},
      lessonInfo: {},
      typeComp: {'doc': 'expRunDoc', 'report': 'expRunReport'},
      type: 'doc',
      isRemote: false, // 是不是远程
      tunnel: null, // 远程桌面通道
      client: null, // 远程桌面客户端
      display: null, //
      clientProperties: {
        minScale: 1,
        maxScale: 3,
        scale: 1,
        autoFit: true,
        minWidth: 1280, // 最小宽度
        minHeight: 800 // 最小高度
      }, // 远程桌面配置项
      localCursor: false, // 是否正在使用本地硬件鼠标光标。
      showLabTools: false,
      showDoc: false, // 是否展示文档
      softwares: [], // 仿真软件
      clipBoardDialog: false, // 剪贴板显示
      directionsDialog: false, //使用说明显示
      clipBoardText: '', // 剪贴板文本
      time: '00:00',
      timer: null,
      leftTime: 0,// 剩余秒数
      isSave: false, // 是否保存实验报告
      isStatus: false,
      beforeunload: false, // 当页面卸载（关闭）或刷新
      moveDoc: { //显示文档初始位置
        x: null,
        y: null
      },
      moveTools: { //显示工具栏位置
        x: null,
        y: null
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
    typeIsRemote () {
      return this.startType === 'remote'
    }
  },
  watch: {
    laya3D: {
      immediate: false,
      handler(val) {
        if (val) {
          // 开始实验计时
          this.startExpTime = new Date()
        }
      }
    },
    "clientProperties.scale" (newV) {
      let scale = newV
      const {minScale, maxScale} = this.clientProperties
      if (scale < minScale) {
        scale = minScale
      }
      if (scale > maxScale) {
        scale = maxScale
      }
      if (scale !== newV) {
        this.clientProperties.scale = scale
      } else {
        this.display.scale(scale)
      }
    }
  },
  created () {
    const {uid, ticket, type, labExpUid, key: shenbaoKey} = this.$route.params
    this.startType = type
    this.uid = uid
    this.ticket = ticket
    this.baseUrl = baseUrl
    this.labExpUid = labExpUid
    this.shenbaoKey = shenbaoKey
    this.path = path
    // 页面全屏
    this.deskFull = false
    this.fullScreen()
  },
  mounted () {
    this.openFullScreen(1)
    window.history.pushState(null, null, document.URL)
    window.addEventListener('popstate', this.onBrowserBack, false)
    window.addEventListener('beforeunload', this.onBeforeunload, false)
    this.$nextTick(() => {
      getMyExpDetail(this.uid).then(res => {
        const {uid, labUid, name, status} = res
        this.getLessonInfo(labUid)
        this.expContentType = res.expContentType
        if (res.report) this.newReport = res.report
        if (status === 2) this.isStatus = true
        if (res.softs) {
          const softList = JSON.parse(res.softs)
          this.softwares = softList
          if (softList.length > 0) {
            const software = softList[0]
            const { mode } = software
            try {
              let { appprama } = software
              const {layaUrl} = appprama
              this.laya3D = layaUrl && layaUrl !== ""
            } catch (e) {
              this.laya3D = false
            }
            if (mode === 2) { // 远程
              this.isRemote = true
              this.setCurrentExpInfo({
                uid,
                name,
                type: this.startType,
                labExpUid: this.labExpUid
              })
            }
            this.openFullScreen(mode)
          }
        } else {
          const html = filterMarkdownHtml(res)
          const {softInfos} = html
          this.softwares = softInfos
          if (this.typeIsRemote && softInfos.length > 0) {
            const software = softInfos[0]
            const {mode} = software
            try {
              let { appprama } = software
              const {layaUrl} = appprama
              this.laya3D = layaUrl && layaUrl !== ""
            } catch (e) {
              this.laya3D = false
            }
            if (mode === 2) { // 远程
              this.isRemote = true
              this.setCurrentExpInfo({
                uid,
                name,
                type: this.startType,
                labExpUid: this.labExpUid
              })
            }
            this.openFullScreen(mode)
          }
        }
        this.expData = res
      }).catch(err => {
        window.console.error(err)
        this.$message.error(err.message || err.type || err)
        this.$router.go(-1)
      })
    })
  },
  beforeDestroy() {
    if (this.laya3D) {
      // 退出时，保持实验时长
      let startTime = this.startExpTime
      let endTime = new Date()
      let timeSpending = Math.round((endTime.getTime() - startTime.getTime()) / 1000)
      let {
        id: userId,
        username,
        nickname
      } = this.userInfo
      let {
        name: expName,
        labUid: lessonUid
      } = this.expData
      let {lessonName} = this.lessonInfo
      let obj = {
        labExpUid: this.labExpUid,
        lessonUid,
        lessonName,
        expUid: this.uid,
        expName,
        userId,
        username,
        nickname,
        startTime: startTime.format('yyyy-MM-dd hh:mm:ss'),
        endTime: endTime.format('yyyy-MM-dd hh:mm:ss'),
        timeSpending
      }
      add(obj).catch(err => {
        this.$message.error(err.message)
      })
    }
    this.closeSoftWare(true)
  },
  destroyed() {
    // 当页面销毁必须要移除这个事件，vue不刷新页面，不移除会重复执行这个事件
    window.removeEventListener('popstate', this.onBrowserBack, false)
    window.removeEventListener('beforeunload', this.onBeforeunload, false)
  },
  methods: {
    ...mapActions(['setCurrentExpInfo']),
    handTestSpeed() {
      this.$refs['speedTest'].changeVisible(true)
    },
    handShowDoc() { //判断显示文档是点击事件还是拖拽事件
      let isClick = this.$refs.showDoc.getAttribute('flag')
      if (isClick === 'true') this.showDoc = !this.showDoc
      else return false
    },
    mouseDownHandDoc(event) {//显示文档的鼠标按下事件
      this.moveDoc.y = event.pageY - this.$refs.showDoc.offsetTop
      event.currentTarget.style.cursor = 'move'
      window.onmousemove = this.mouseMoveHandDoc
      this.$refs.showDoc.setAttribute('flag', "false")
      const firstTime = new Date().getTime()
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
        // onmouseup 时的时间，并计算差值
        const lastTime = new Date().getTime()
        if ((lastTime - firstTime) < 200) {
          this.$refs.showDoc.setAttribute('flag', "true")
        }
      }
    },
    mouseMoveHandDoc(event) { //显示文档的鼠标移动事件
      this.$refs.showDoc.style.top = event.pageY - this.moveDoc.y + 'px'
    },
    mouseUpHandDoc(event) { //显示文档的鼠标抬起事件
      window.onmousemove = null
      event.currentTarget.style.cursor = 'move'
    },
    handShowTools() { //判断工具栏是点击事件还是拖拽事件
      let isClick = this.$refs.showTools.getAttribute('flag')
      if (isClick === 'true') this.showLabTools = !this.showLabTools
      else return false
    },
    mouseDownHandTools(event) { //工具栏的鼠标按下事件
      this.moveTools.y = event.pageY - this.$refs.showTools.offsetTop
      event.currentTarget.style.cursor = 'move'
      window.onmousemove = this.mouseMoveHandTools
      this.$refs.showTools.setAttribute('flag', "false")
      const firstTime = new Date().getTime()
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
        // onmouseup 时的时间，并计算差值
        const lastTime = new Date().getTime()
        if ((lastTime - firstTime) < 200) {
          this.$refs.showTools.setAttribute('flag', "true")
        }
      }
    },

    mouseMoveHandTools(event) { //工具栏的鼠标移动事件
      this.$refs.showTools.style.top = event.pageY - this.moveTools.y + 'px'
    },

    mouseUpHandTools(event) { //工具栏的鼠标抬起事件
      window.onmousemove = null
      event.currentTarget.style.cursor = 'move'
    },
    // 返回
    onBrowserBack() {
      this.$message.warning('正在离开做实验界面，实验环境将不会保存!')
      this.closeSoftWare()
    },
    // 当页面卸载（关闭）或刷新时调用
    onBeforeunload(e) {
      // 不是所有浏览器都支持提示信息的修改
      let confirmationMessage = '请先保存您编辑的内容,否则您修改的信息会丢失。'
      e.returnValue = confirmationMessage
      return confirmationMessage
    },
    openFullScreen(mode) {
      if (!['lessonExpStart', 'shenbaoExpStart'].includes(this.$route.name)) {
        return
      }

      if (mode === 2) {
        this.initRemote()
      } else {
        this.isLoading = false
      }
    },
    addClientEvent() {
      this.client.onerror = this.clientOnError
      this.client.onmessage = this.clientOnMessage
      this.client.onstatechange = this.clientOnStatechange
      this.client.onclipboard = this.clientOnClipboard

      this.display = this.client.getDisplay()
      this.addClientDisplayEvent()
    },
    /**
     * 连接错误
     */
    clientOnError(error) {
      this.$message.error(error.message)
      this.closeSoftWare(true)
    },
    clientOnMessage(parameters) {
      if (parameters instanceof Array && parameters.length > 0) {
        let duration = Number(parameters[0]) // 持续时间（毫秒）
        if (isNaN(duration)) {
          return
        }
        let cutoffTime = new Date().getTime() + duration
        this.getCountDown(new Date(cutoffTime))
      }
    },
    clientOnStatechange(state) {
      // STATE_IDLE          = 0;
      // STATE_CONNECTING    = 1;
      // STATE_WAITING       = 2;
      // STATE_CONNECTED     = 3;
      // STATE_DISCONNECTING = 4;
      // STATE_DISCONNECTED  = 5;
      if (state < 4) {
        this.isLoading = true
      } else if (state > 2) {
        this.isLoading = false
      }
      if (state === 4) {
        this.closeSoftWare(true)
      }
    },
    clientOnClipboard(stream, mimetype) {
      let reader
      let data = ''
      // If the received data is text, read it as a simple string
      if (/^text\//.exec(mimetype)) {
        reader = new Guacamole.StringReader(stream)
        // Assemble received data into a single string
        reader.ontext = function textReceived(text) {
          data += text
        }
        // Set clipboard contents once stream is finished
        reader.onend = () => {
          this.clipBoardText = data
          if (this.isJSON(this.clipBoardText)) {
            let obj = {
              cmd: undefined,
              param: undefined
            }
            try {
              obj = JSON.parse(this.clipBoardText)
            } catch (e) {
              console.error(e)
            }
            if (obj.cmd == 0) { // 新开
              if (obj.param === 'submit') {
                this.openScore = true
              } else if (obj.param === 'close') {
                this.closeSoftWare(true)
              }
            } else if (obj.cmd == 1) { // 弹窗
              let str = obj.param
              if (str.indexOf('http') > -1) {
                this.url5g = obj.param
              } else {
                this.url5g = `${this.baseUrl}${this.path}${obj.param}`
              }
              document.getElementById('iframeId').contentWindow.location.reload(true)
              this.open5G = true
            } else if (obj.cmd == 2) {
              let str = obj.param
              if (str.indexOf('http') > -1) {
                window.open(obj.param, '_blank')
              } else {
                window.open(`${this.baseUrl}${this.path}${obj.param}`, '_blank')
              }
            }
          }
        }
      } else { // Otherwise read the clipboard data as a Blob
        reader = new Guacamole.BlobReader(stream, mimetype)
        reader.onend = () => {
          this.clipBoardText = data
        }
      }
    },
    addClientDisplayEvent() {
      this.addClientMouseEvent()
    },
    addClientMouseEvent() {
      // 获取鼠标
      const mouse = new Guacamole.Mouse(this.display.getElement())
      mouse.onmousemove = (mouseState) => {
        this.client.sendMouseState(mouseState);
      };
      // 获取键盘
      const keyboard = new Guacamole.Keyboard(document)

      if (!this.showDoc || this.mouseFlag) { // 判断键盘事件 5.27修改
        keyboard.onkeydown = (keysym) => {
          this.client.sendKeyEvent(1, keysym);
        };
        keyboard.onkeyup = (keysym) => {
          this.client.sendKeyEvent(0, keysym);
        };
      }

      mouse.onmousedown = (mouseState) => {
        keyboard.onkeydown = (keysym) => {
          this.client.sendKeyEvent(1, keysym);
        };
        keyboard.onkeyup = (keysym) => {
          this.client.sendKeyEvent(0, keysym);
        };
        document.body.focus();
        this.handleMouseState(mouseState);
      };
      mouse.onmouseout = () => {
        if (!this.display) return;
        this.display.showCursor(false);
        keyboard.onkeydown = null;
        keyboard.onkeyup = null;
      };

      // mouse.onmousemove = this.clientMouseOnMove
      // // 在转发事件之前，确保通过鼠标向下重新获得焦点
      // mouse.onmousedown = this.clientMouseOnDown
      mouse.onmouseup = mouse.onmousemove = this.handleMouseState
      // mouse.onmouseout = this.clientMouseOnOut
    },
    keyboardOnDown(keysym) {
      this.client.sendKeyEvent(1, keysym)
    },
    keyboardOnUp(keysym) {
      this.client.sendKeyEvent(0, keysym)
    },
    clientMouseOnMove(mouseState) {
      this.client.sendMouseState(mouseState)
    },
    clientMouseOnOut() {
      if (!this.display)
        return

      // 获取键盘
      const keyboard = new Guacamole.Keyboard(document)

      this.display.showCursor(false)
      if (!this.showDoc || this.mouseFlag) {
        keyboard.onkeydown = null
        keyboard.onkeyup = null
      }
    },
    clientMouseOnDown(mouseState) {
      // 获取键盘
      const keyboard = new Guacamole.Keyboard(document)

      if (!this.showDoc || this.mouseFlag) {
        keyboard.onkeydown = keysym => {
          this.client.sendKeyEvent(1, keysym)
        }
        keyboard.onkeyup = keysym => {
          this.client.sendKeyEvent(0, keysym)
        }
      }
      document.body.focus()
      this.handleMouseState(mouseState)
    },
    // 添加虚拟机处理事件
    addEvent() {
      // 页面关闭
      window.onunload = function () {
        this.closeSoftWare()
      }

      window.addEventListener('resize', () => {
        this.mainElementResized()
      })
    },
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          let obj = JSON.parse(str);
          return !!(typeof obj == 'object' && obj);
        } catch (e) {
          return false;
        }
      }
    },
    // 全屏、退出全屏
    fullScreen() {
      let state = this.deskFull
      if (state) {
        // 退出全屏
        exitFullScreen()
      } else {
        // 桌面全屏
        reqFullScreen()
      }
      this.showLabTools = false
      this.deskFull = !state
    },
    // 倒计时
    getCountDown(stopDate) {
      const stopTime = stopDate.getTime()
      const newTime = new Date().getTime()
      this.leftTime = (stopTime - newTime) / 1000
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        if (this.leftTime >= 0) {
          let h = Math.floor(this.leftTime / 3600)
          let m = Math.floor((this.leftTime - 3600 * h) / 60)
          let s = ((this.leftTime - 3600 * h) % 60).toString()
          if (h < 10) h = "0" + h
          if (m < 10) m = "0" + m
          if (s < 10) s = "0" + s
          this.time = h + ':' + m + ':' + s.split('.')[0]
          this.leftTime--
          if (Math.floor(this.leftTime) === 600) { // 10分钟提醒
            // 时间到了，弹出框询问是否延时
            this.$confirm('您的实验时间还剩下十分钟, 是否延长实验时间?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.addTimeToSoft()
            }).catch(() => {
            })
          }
        } else {
          clearInterval(this.timer)
          // 关闭仿真软件，退出当前页面。
          this.$alert('实验时间已到期，即将退出当前页面！', '实验到期通知', {
            confirmButtonText: '确定'
          })
          this.closeSoftWare(true)
        }
      }, 1000)
    },
    /**
     * 延长仿真软件使用时长
     */
    addTimeToSoft() {
      this.delayedCount--
      this.tunnel.sendMessage('extentEndTime')
    },
    /**
     * 处理手动退出实验项目
     */
    handleConfirmClose() {
      this.$confirm('停止实验后，实验环境将不会保存, 是否确认停止实验?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.closeSoftWare(true)
      }).catch(() => {
      })
    },
    /**
     * 关闭当前的仿真软件
     */
    async closeSoftWare(close = false) {
      if (!this.laya3D && close && this.tunnel && this.client) {
        this.tunnel.sendMessage("logout")
        this.tunnel = null
        await setTimeout(() => {
          this.client.disconnect()
          this.client = null
        }, 2000)
      }

      if (this.timer)
        clearInterval(this.timer)

      if (close) {
        this.loading = this.$loading({
          lock: true,
          text: '亲,实验机正在停止中 ..... 请稍后哟 !',
          spinner: 'el-icon-loading',
          background: '  rgba(255,255,255,0.3)',
          target: document.querySelector('.exp-run-page'),
        })
        this.setCurrentExpInfo(null)
        this.deskFull = true
        this.isSave = true
      }

      setTimeout(() => {
        if (this.loading)
          this.loading.close()
        this.loading = null
        this.exitPage()
      }, this.laya3D ? 10 : 6000)
    },
    exitPage() {
      const {shenbaoKey} = this
      const {labUid} = this.expData

      this.deskFull = true
      this.fullScreen()

      if (!['lessonExpStart', 'shenbaoExpStart'].includes(this.$route.name)) {
        return
      }
      const {path} = this.$route
      let newPath = path
      if (shenbaoKey) {
        newPath = {
          name: "shenbaoV2",
          params: {
            key: shenbaoKey,
          },
        }
      } else if (labUid) {
        newPath = {
          name: "lesson",
          params: {
            uid: labUid,
            type: "exp",
          },
        }
      }
      if (path !== newPath)
        this.$router.push(newPath)
    },
    /**
     * 点击调起本地仿真软件
     */
    clickSoftLocal(soft) {
      const param = {
        token: this.token,
        id: this.uid,
        ip: intranetIp,
        port: softPort
      }
      soft.appprama = {
        ...soft.appprama,
        ...param
      }
      getLocalLink({
        id: soft.id,
        taskUid: this.uid,
        name: soft.name,
        mode: 1,
        publicFlag: 0,
        appprama: JSON.stringify(soft.appprama)
      }).then(res => {
        const {url} = res
        try {
          window.location.href = url
        } catch (err) {
          const {name, message} = err
          this.$message.error(`${name}：${message}`)
        }
      })
    },
    // 初始化远程桌面
    initRemote() {
      this.$nextTick(() => {
        const {minWidth, minHeight} = this.clientProperties
        let offsetWidth = 0
        let offsetHeight = 0
        if (this.$refs.main) {
          offsetWidth = this.$refs.main.offsetWidth
          offsetHeight = this.$refs.main.offsetHeight
        }
        const pixel_density = window.devicePixelRatio || 1
        const optimal_dpi = pixel_density * 96
        const optimal_width = Math.max(offsetWidth * pixel_density, minWidth)
        const optimal_height = Math.max(offsetHeight * pixel_density, minHeight)

        const soft = this.softwares[0]
        const {appprama} = soft || {}
        const {layaUrl} = appprama
        if (layaUrl) {
          let iframe = document.createElement('iframe')
          let urlData = {
            token: this.token
          }
          try {
            urlData = {
              ...urlData,
              ...JSON.parse(JSON.stringify(appprama))
            }
          }catch (e) {
            console.warn(e)
          }
          delete urlData.layaUrl
          let pageUrl = `${this.$options.filters["filterUrl"](layaUrl)}`;
          iframe.src = jumpToSearchUrl(urlData, pageUrl);
          iframe.width = '100%'
          iframe.height = '100%'

          this.$refs['display'].appendChild(iframe)

          this.laya3D = true
          this.isLoading = false
          return
        }
        this.laya3D = false
        this.showDoc = true

        let wsUrl = getExpRuningUrl({
          ticket: this.ticket,
          GUAC_WIDTH: Math.floor(optimal_width),
          GUAC_HEIGHT: Math.floor(optimal_height),
          GUAC_DPI: Math.floor(optimal_dpi),
        })
        let webSocketTunnel = new Guacamole.WebSocketTunnel(wsUrl)
        let chainedTunnel = new Guacamole.ChainedTunnel(webSocketTunnel)
        let client = new Guacamole.Client(chainedTunnel)
        // 组装ws请求路径参数
        this.tunnel = chainedTunnel

        this.client = client
        this.addClientEvent()

        // 把生成的display 放到div里
        const displayElement = this.display.getElement()
        displayElement.style.zIndex = 999
        this.$refs.display.innerHTML = ''
        this.$refs.display.appendChild(displayElement)
        // 客户端连接
        this.client.connect()
        // 添加事件
        this.addEvent()
      })
    },
    // 发送剪切板内容
    handleClipBoard() {
      this.clipBoardDialog = false
      const stream = this.client.createClipboardStream('text/plain')
      const writer = new Guacamole.StringWriter(stream)
      // Send text chunks
      for (let i = 0; i < this.clipBoardText.length; i += 4096)
        writer.sendText(this.clipBoardText.substring(i, i + 4096))
      // Close stream
      writer.sendEnd()
    },
    // 根据当前窗口更新附加的guacamole.client的比例
    updateDisplayScale() {
      if (!this.display || !this.$refs.main) return

      const {autoFit, minWidth, minHeight} = this.clientProperties

      let {minScale, maxScale, scale} = this.clientProperties
      let width = 0
      let height = 0
      if (this.$refs.main) {
        width = this.$refs.main.offsetWidth
        height = this.$refs.main.offsetHeight
      }
      width = Math.max(width, minWidth)
      height = Math.max(height, minHeight)

      let wScale = width / Math.max(
          this.display.getWidth() > 0 ? this.display.getWidth() : window.screen.width,
          minScale
      )
      let hScale = height / Math.max(
          this.display.getHeight() > 0 ? this.display.getHeight() : window.screen.height,
          minScale
      )
      minScale = Math.min(wScale, hScale)
      maxScale = Math.max(maxScale, wScale, hScale)

      if (this.display.getScale() < minScale || autoFit) {
        scale = minScale
      } else if (this.display.getScale() > maxScale) {
        scale = maxScale
      }
      this.clientProperties.minScale = minScale
      this.clientProperties.maxScale = maxScale
      this.clientProperties.scale = scale
    },
    // 滚动客户机视图，使鼠标光标可见
    scrollToMouse(mouseState) {
      // Determine mouse position within view
      let mouse_view_x = mouseState.x + this.$refs.display.offsetLeft - this.$refs.main.scrollLeft
      let mouse_view_y = mouseState.y + this.$refs.display.offsetTop - this.$refs.main.scrollTop

      // Determine viewport dimensions
      let view_width = 0
      let view_height = 0
      if (this.$refs.main) {
        view_width = this.$refs.main.offsetWidth
        view_height = this.$refs.main.offsetHeight
      }

      // Determine scroll amounts based on mouse position relative to document
      let scroll_amount_x
      if (mouse_view_x > view_width)
        scroll_amount_x = mouse_view_x - view_width
      else if (mouse_view_x < 0)
        scroll_amount_x = mouse_view_x
      else
        scroll_amount_x = 0

      let scroll_amount_y
      if (mouse_view_y > view_height)
        scroll_amount_y = mouse_view_y - view_height
      else if (mouse_view_y < 0)
        scroll_amount_y = mouse_view_y
      else
        scroll_amount_y = 0
      // Scroll (if necessary) to keep mouse on screen.
      this.$refs.main.scrollLeft += scroll_amount_x
      this.$refs.main.scrollTop += scroll_amount_y
    },
    // 将给定的鼠标状态发送到当前客户端。
    sendScaledMouseState(mouseState) {
      const {scrollTop, scrollLeft} = this.$refs.display
      // Scale event by current scale
      let scaledState = new Guacamole.Mouse.State(
          (mouseState.x + scrollLeft) / this.display.getScale(),
          (mouseState.y + scrollTop) / this.display.getScale(),
          mouseState.left,
          mouseState.middle,
          mouseState.right,
          mouseState.up,
          mouseState.down
      )
      // Send mouse event
      this.client.sendMouseState(scaledState)
    },
    /**
     * 处理源自用户实际鼠标的鼠标事件。
     * 这与handleEmulatedMouseState（）的不同之处在于
     * 只有当用户的浏览器
     * 不支持显式设置硬件鼠标光标。
     */
    handleMouseState(mouseState) {
      // Do not attempt to handle mouse state changes if the client
      // or display are not yet available
      if (!this.client || !this.display)
        return
      // Send mouse state, show cursor if necessary
      this.display.showCursor(!this.localCursor)
      this.sendScaledMouseState(mouseState)
    },
    mainElementResized() {
      if (this.client && this.display) {
        const {minWidth, minHeight} = this.clientProperties
        let pixelDensity = window.devicePixelRatio || 1
        let width = 0
        let height = 0
        if (this.$refs.main) {
          width = this.$refs.main.offsetWidth * pixelDensity
          height = this.$refs.main.offsetHeight * pixelDensity
        }
        width = Math.max(width, minWidth)
        height = Math.max(height, minHeight)
        if (this.display.getWidth() !== width || this.display.getHeight() !== height)
          this.client.sendSize(width, height)
      }
      this.updateDisplayScale()
    },
    mouseLeftClick() {
      this.mouseFlag = false
    },
    mouseRightClick() {
      this.mouseFlag = true
    },
    getLessonInfo(labLessonUid) {
      getDetail(labLessonUid)
          .then((data) => {
            this.lessonInfo = data;
          })
          .catch(() => {
            this.lessonInfo = null;
          });
    },
  }
}
</script>

<style lang="less">
.exp-run-page {
  .dialog5G {
    .el-dialog__body {
      height: 100%;
    }
  }

  .score-see {
    .el-dialog__body {
      padding-right: 0;
    }
  }
}
</style>

<style lang="less" scoped>
@import "~@/assets/css/exp-runing";

.exp-run-page {
  .left-tabs-close {
    float: right;
    margin-right: 36px;
  }

  .soft-list {
    top: 142px;
    right: 1px;
    z-index: 999;
    width: 85px;
    //min-height: 100px;
    border: 1px solid #e7e7e7;
    position: absolute;
    background-color: #fff;
    overflow: hidden;
    min-height: calc(100% - 220px);

    .soft-title {
      color: #333;
      text-align: center;
      width: 66px;
      height: 43px;
      line-height: 43px;
      padding-top: 9px;
      margin: 0 auto;
      border-bottom: #f0f0f0 1px solid;
      font-size: 13px;
      cursor: default;
    }

    .soft-item {
      display: block;
      text-align: center;
      width: 66px;
      height: 76px;
      margin: 0 auto;
      border-bottom: #f0f0f0 1px solid;
      color: #666;
      text-decoration: none;
      overflow: hidden;
      font: 12px arial;
      cursor: pointer;

      img {
        width: 36px;
        height: 36px;
        display: block;
        margin: 10px auto 5px;
        cursor: pointer;
      }

      &:hover {
        background-color: #ebeef5;
      }
    }
  }

  .exp-run-main {
    .main-right {
      width: 65%;
      height: 100%;
      margin-left: 35%;
      position: relative;

      .vm-area {
        height: 100%;
        box-shadow: -3px -1px 2px 0 #e0d6d6;

        .desktop-content {
          width: 100%;
          height: 100%;
          position: absolute;
          overflow: hidden;

          .display {
            width: 100%;
            height: 100%;

            #display {
              width: 100%;
              height: 100%;
              overflow: auto;
              display: flex;
              // justify-content: center;
              // align-items: center;
              background: #000;
            }
          }
        }

        .action-btn {
          position: absolute;
          width: 28px;
          font-size: 14px;
          height: 94px;
          background-color: #464646;
          color: #fff;
          text-align: center;
          padding: 8px;
          cursor: pointer;
          z-index: 1100;
        }

        .hide {
          top: 40%;
          border-radius: 7px 0 0 7px;
          left: -28px;
        }

        .show {
          top: 40%;
          border-radius: 0 7px 7px 0;
          left: 0;
        }

        .tools-bar {
          width: 0;
          height: 100%;
          position: absolute;
          right: 0;
          transition: width ease-in-out 0.5s;
          background-color: rgba(255, 255, 255, 0.9);
          box-shadow: -1px 0 0 rgba(70, 70, 70, 0.25);
          z-index: 9999;

          &.tb-show {
            width: 200px;
          }

          .btn-list {
            margin-top: 72px;
            text-align: center;

            > * {
              width: 70%;
              display: inline-block;

              &:not(:last-child) {
                margin-bottom: 12px;
              }
            }

            .title-time {
              time {
                font-size: 2em;
              }
            }

            .el-input {
              display: inline-table;
            }
          }

          .tool-list {
            margin: 40px 0 0 50px;

            .tool {
              margin: 20px 0;
              position: relative;
              cursor: pointer;

              img {
                vertical-align: middle;
                width: 22px;
              }

              .tool-title {
                font-size: 16px;
                margin-left: 10px;
                position: absolute;
                top: 1px;
              }
            }
          }
        }

        .tools-hide {
          top: 30%;
          right: 200px;
          height: 115px;
          border-radius: 7px 0 0 7px;
        }

        .tools-show {
          top: 30%;
          right: 0;
          height: 115px;
          border-radius: 7px 0 0 7px;
        }
      }
    }

    .full {
      width: 100%;
      margin-left: 0;
    }

    &.is-full {
      .main-right {
        width: 0;
        margin-left: 100%;
      }
    }
  }

  .clipboard-body {
    .text {
      font-size: 16px;
      line-height: 2em;
    }

    .el-textarea {
      margin: 10px 0;
    }
  }
}
</style>
